import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useToast } from "../lib/toast";
import { FieldInput } from "../components/ui/Field";
import { Button } from "../components/ui/Button";
import { Card } from "../components/ui/Card";

/** Pre-login self-registration — a target-state addition (see ADLC Source
 * Conflict Register #7: the legacy's own pre-login creation screen could
 * not be located in the reviewed codebase). Plant-access-request approval
 * happens after first login, matching the code-verified legacy workflow. */
export function Register() {
  const [form, setForm] = useState({ email: "", password: "", firstName: "", lastName: "", company: "" });
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/register", { ...form, turnstileToken: "sandbox-token" });
      toast("Account created. Sign in, then request plant access.");
      navigate("/login");
    } catch (err: any) {
      toast(err?.message ?? "Registration failed", "error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-surface-0 p-6">
      <Card className="w-full max-w-md p-6">
        <h2 className="text-xl font-bold mb-1">Supplier registration</h2>
        <p className="text-sm text-slate-500 mb-6">Create your account, then request access to the SBD plants you ship to.</p>
        <form onSubmit={submit} className="space-y-3">
          <FieldInput label="Email" type="email" required value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} />
          <FieldInput label="Password" type="password" required minLength={8} value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} />
          <div className="grid grid-cols-2 gap-3">
            <FieldInput label="First name" required value={form.firstName} onChange={(e) => setForm((f) => ({ ...f, firstName: e.target.value }))} />
            <FieldInput label="Last name" required value={form.lastName} onChange={(e) => setForm((f) => ({ ...f, lastName: e.target.value }))} />
          </div>
          <FieldInput label="Company" required value={form.company} onChange={(e) => setForm((f) => ({ ...f, company: e.target.value }))} />
          <Button type="submit" disabled={loading} className="w-full justify-center mt-2">
            {loading ? "Creating account…" : "Create account"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
